import {
  QueryTarget,
  roboqlFields,
  roboqlComparatorsByType,
} from "@/shared/domain/query";
import { Comparator, isComparator } from "@/types";

export type SearchFieldType = "date" | "metadata" | "tags" | "other";

// JSON-compatible subset of keyof RoboqlComparatorsByType
export type MetadataType = "string" | "number" | "boolean";

export interface SearchField {
  name: string;
  type: SearchFieldType;
}

export function comparatorForSearchField(
  searchField: SearchField,
  queryTarget: QueryTarget,
  metadataType: MetadataType,
): Comparator[] {
  const field = roboqlFields[queryTarget].find((field) => {
    return field.label === searchField.name;
  });

  if (!field || !field.comparators) {
    return [];
  }

  let comparators: Comparator[] = field.comparators.filter(isComparator);

  // A metadata field declares comparators for every value type; narrow to
  // those valid for this field's concrete runtime type.
  if (searchField.type === "metadata") {
    const allowed = roboqlComparatorsByType[metadataType];
    comparators = comparators.filter((comparator) => {
      return allowed.includes(comparator);
    });
  }

  return comparators.sort((a, b) => a.localeCompare(b));
}
